module.exports = __webpack_public_path__ + "img/macan.311d45e0.svg";